module.exports = __webpack_public_path__ + "media/site_templates/www.heatingservices.com.au/images/splash-a87f7c41a757786aed79c669866ef2d6.jpg";